// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const simipour: PokeData = {
  "id": 516,
  "name": "simipour",
  "height": 10,
  "weight": 290,
  "base_experience": 174,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "leer",
    "lick",
    "fury-swipes",
    "scald"
  ],
  "moves": [
    "leer",
    "lick",
    "bubble-beam",
    "water-spout",
    "rain-dance",
    "brine",
    "liquidation",
    "aqua-cutter",
    "life-dew",
    "bubble",
    "aqua-tail",
    "hydro-pump",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 264,
    "item": null,
    "species": [
      {
        "name": "panpour",
        "order": 516,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "simipour",
        "order": 517,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 515,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "water-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 103,
    "speed": 151,
    "ability_power": 146
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
